export const SET_CONFIGURATIONS = '[💚] set configurations';
export const SET_LIST_PATIENTS = '[💚] set list patients';
export const SET_LOADING_PATIENTS = '[💚] set loading patients';
export const SET_LIST_EXAMS = '[💚] set list exams';
export const SET_LIST_USERS = '[💚] set list users';
export const SET_LOADING_EXAMS = '[💚] set loading exams';
export const SET_LIST_CLINICS = '[💚] set list clinics';
export const SET_LIST_CLINICS_DENTISTS = '[💚] set list clinics dentists';
export const SET_LOADING_CLINICS = '[💚] set loading clinics';
export const SET_LAST_CLINICS = '[💚] set last clinic selected';
export const SET_LOADING_COMPANY_USERS = '[💚] set loading users';
export const HANDLE_LOAD_EXAMS = '[🚀] handle loading exams';
export const HANDLE_LOAD_COMPANY_USERS = '[🚀] handle loading company users';
export const HANDLE_LOAD_LAST_CLINIC = '[🚀] handle load last selected clinic';
export const HANDLE_LOAD_COMPANY_CLINICS = '[🚀] handle load company clinics';
export const HANDLE_SEARCH_SCHEDULER = '[🚀] handle SEARCH SCHEDULER CONFIG';
export const HANDLE_SEARCH_MY_SCHEDULER = '[🚀] handle SEARCH MY SCHEDULER CONFIG';
export const HANDLE_SEARCH_APPOINTMENTS = '[🚀] handle SEARCH APPOINTMENTS';
export const HANDLE_RESERVE_APPOINTMENTS = '[🚀] handle RESERVE APPOINTMENTS';
export const SET_LOADING_APPOINTMENTS = '[📅] handle load appointments';
export const SET_LOADING_RESERVE_APPOINTMENTS = '[📅] handle load reserving appointments';
export const SET_LOADING_SCHEDULERS = '[📅] handle load schedulers';
export const SET_APPOINTMENT = '[📅] set appointment';
export const SET_LIST_SCHEDULERS = '[📅] set list schedulers';
export const SET_LIST_APPOINTMENTS = '[💚] set list appointments';
export const HANDLE_SEARCH_SCHEDULER_STATES = '[🚀] handle SEARCH SCHEDULER STATES';
export const SET_LOADING_SCHEDULER_STATES = '[📅] handle load scheduler states';
export const SET_LIST_SCHEDULER_STATES = '[📅] set list scheduler states';
export const SET_SCHEDULER_STATE = '[📅] set scheduler state';
export const REMOVE_SCHEDULER_STATE = '[📅] remove scheduler state';
export const HANDLE_CLEAN_OLD_APPOINTMENTS = '[🧹] handle clean old appointments';
export const SET_CLEAN_APPOINTMENTS_RESULT = '[📅] set clean appointments result';
export const HANDLE_PUT_APPOINTMENT_STATUS = '[🚀] handle PUT APPOINTMENT STATUS';
export const SET_LOADING_PUT_APPOINTMENT_STATUS = '[📅] handle load put appointment status';
export const SET_PENDING_FILES = '[📁] set pending files';
export const CLEAR_PENDING_FILES = '[📁] clear pending files';
export const SET_PENDING_FILE = '[📁] set pending file';
export const SET_SELECTED_PATIENT = '[💚] set selected patient';
